var _defs, _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoTg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "pw2",
    x1: 16.8101,
    y1: 4.10908,
    x2: 10.3101,
    y2: 19.2755,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#37AEE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E96C8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pw3",
    x1: 13.9735,
    y1: 13.4068,
    x2: 16.6818,
    y2: 17.7401,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF7FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26 13C26 20.1825 20.1825 26 13 26C5.8175 26 0 20.1825 0 13C0 5.8175 5.8175 0 13 0C20.1825 0 26 5.8175 26 13Z",
    fill: "url(#pw2)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M10.6171 18.9583C10.1946 18.9583 10.2705 18.7958 10.1188 18.395L8.88379 14.3217L16.5538 9.53333L17.453 9.77166L16.7055 11.8083L10.6171 18.9583Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6162 18.9584C10.9412 18.9584 11.082 18.8067 11.2662 18.6334C11.5479 18.3625 15.1662 14.8417 15.1662 14.8417L12.9454 14.3L10.8613 15.6514L10.6162 18.85V18.9584Z",
    fill: "#A9C6D2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8328 15.6433L16.0761 19.5108C16.672 19.8358 17.1053 19.6733 17.257 18.9583L19.3911 8.90497C19.6078 8.02747 19.0553 7.63747 18.4811 7.89747L5.95778 12.7291C5.10194 13.0758 5.11278 13.5525 5.80611 13.7583L9.02361 14.7658L16.4661 10.075C16.8128 9.8583 17.1378 9.97747 16.8778 10.2158L10.8328 15.6433Z",
    fill: "url(#pw3)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoTg);
export default __webpack_public_path__ + "static/media/ico-tg.42a408af.svg";
export { ForwardRef as ReactComponent };